import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Paper,
    Stack,
    Box,
    IconButton,
    Divider,
    Chip,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material"
import { Add, Delete } from "@mui/icons-material"
import { useContext, useEffect, useState } from "react"
import ModalTrigger from "./ModalTrigger"
import { Icon } from "@iconify/react/dist/iconify.js"
import ModalAction from "./ModalAction"
import { toast } from "react-toastify"
import api from "../../services/api"
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext"

export const triggerTypes = {
    comment: "Comentário em publicação ou Reels",
    "response-story": "Resposta ao Story",
    "dm-message": "Mensagem na DM",
}

const actionTypes = {
    "dm-message": "Enviar Mensagem na DM",
    "response-comment": "Responder comentário",
}

export const triggerConditions = {
    "text-exact": "Palavra ou frase exata",
    "text-contains": "Contem a(s) palavras(s)",
    "text-starts-with": "Texto começa com",
    "text-ends-with": "Texto termina com",
    "any-message": "Qualquer mensagem ou interação",
}

function ModalAutomation({
    open,
    handleClose,
    onSaveAutomation,
    selectedAutomationId,
}) {
    const { whatsApps } = useContext(WhatsAppsContext)
    const [openModalAddTrigger, setOpenModalAddTrigger] = useState(false)
    const [openModalAction, setOpenModalAction] = useState(false)

    const [title, setTitle] = useState("")
    const [triggers, setTriggers] = useState([])
    const [actions, setActions] = useState([])
    const [connections, setConnections] = useState([])
    const [selectedConnection, setSelectedConnection] = useState(null)
    const [loading, setLoading] = useState(false)

    async function getAutomation() {
        try {
            setLoading(true)
            const { data } = await api.get(
                `/automation/byId/${selectedAutomationId}`,
            )

            setTitle(data.title)
            setSelectedConnection(data.whatsappId)
            setTriggers(data.triggers)
            setActions(data.actions)

            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao buscar os dados da automação")
        }
    }

    useEffect(() => {
        if (selectedAutomationId) {
            getAutomation()
        }
    }, [selectedAutomationId])

    const handleAddTrigger = async (data) => {
        try {
            setLoading(true)
            if (selectedAutomationId) {
                data.automationId = selectedAutomationId

                const res = await api.post("/automationTrigger", data)
                data.id = res.data.id
            }
            setTriggers((prevState) => [...prevState, data])
            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao salvar gatilho")
        }
    }

    const handleAddAction = async (data) => {
        try {
            setLoading(true)
            if (selectedAutomationId) {
                data.automationId = selectedAutomationId
                const res = await api.post("/automationAction", data)
                data.id = res.data.id

                toast.success("Ação adicionada com sucesso")
            }
            setActions((prevState) => [...prevState, data])
            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao salvar ação")
        }
    }

    useEffect(() => {
        setConnections(whatsApps.filter((item) => item.channel === "instagram"))
    }, [whatsApps])

    const handleAddAutomation = async () => {
        setLoading(true)
        if (!title || !selectedConnection) {
            toast.error("O tídulo da conexão e a conexão são obrigatórios")
            return
        }
        if (!triggers.length || !actions.length) {
            toast.error("A automação deve ter pelo menos um gatilho e uma ação")
            return
        }

        try {
            if (selectedAutomationId) {
                await api.put(`/automation/byId/${selectedAutomationId}`, {
                    title,
                    automationTriggers: triggers,
                    automationActions: actions,
                    whatsappId: selectedConnection,
                })
            } else {
                await api.post(`/automation`, {
                    title,
                    automationTriggers: triggers,
                    automationActions: actions,
                    whatsappId: selectedConnection,
                })
            }
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao salvar automação")
        }

        setLoading(false)
        onSaveAutomation()

        setTitle("")
        setTriggers([])
        setActions([])
        setSelectedConnection(null)

        handleClose()
    }

    const handleDeleteTrigger = async (index, id) => {
        try {
            setLoading(true)
            if (selectedAutomationId && id) {
                await api.delete(
                    `/automationTrigger/${selectedAutomationId}/${id}`,
                )
                toast.success("Gatilho excluído com sucesso")
            }
            const newTriggers = [...triggers]
            newTriggers.splice(index, 1)

            setTriggers(newTriggers)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao excluir gatilho")
        }
    }

    const handleDeleteAction = async (index, id) => {
        try {
            setLoading(true)

            if (selectedAutomationId && id) {
                await api.delete(
                    `/automationAction/${selectedAutomationId}/${id}`,
                )
                toast.success("Ação excluída com sucesso")
            }
            const newActions = [...actions]
            newActions.splice(index, 1)
            setActions(newActions)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao excluir gatilho")
        }
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <ModalTrigger
                open={openModalAddTrigger}
                handleClose={() => setOpenModalAddTrigger(false)}
                onAddTrigger={handleAddTrigger}
                selectedConnection={selectedConnection}
            />
            <ModalAction
                open={openModalAction}
                onAddAction={handleAddAction}
                handleClose={() => setOpenModalAction(false)}
                enableResponseComent={
                    !!triggers.filter((item) => item.triggerType === "comment")
                        .length
                }
            />
            <DialogTitle>
                {selectedAutomationId ? "Editar automação" : "Nova Automação"}
            </DialogTitle>

            <DialogContent>
                <Stack
                    spacing={2}
                    sx={{
                        mt: 1,
                        mb: 3,
                    }}
                    direction="row"
                >
                    <TextField
                        label="Título"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Defina um título para esta automação"
                        fullWidth
                    />
                    <FormControl fullWidth>
                        <InputLabel id="connection">Conexão</InputLabel>
                        <Select
                            labelId="connection"
                            label="Conexão"
                            value={selectedConnection}
                            fullWidth
                            onChange={(e) =>
                                setSelectedConnection(e.target.value)
                            }
                        >
                            {connections.map((conn) => (
                                <MenuItem key={conn.id} value={conn.id}>
                                    {conn.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction="row" spacing={2}>
                    <Stack sx={{ width: "100%" }} spacing={2}>
                        <Typography variant="h6" gutterBottom>
                            Gatilhos
                        </Typography>
                        {triggers.map((trigger, index) => {
                            const keywords = trigger.keywords

                            return (
                                <Paper
                                    key={index}
                                    variant="outlined"
                                    sx={{ p: 2, width: "100%" }}
                                >
                                    <Typography>
                                        <Icon icon="skill-icons:instagram" />{" "}
                                        {triggerTypes[trigger.triggerType]}
                                    </Typography>
                                    <Typography>
                                        {
                                            triggerConditions[
                                                trigger.triggerCondition
                                            ]
                                        }
                                    </Typography>

                                    {!!keywords?.length &&
                                        keywords.map((keyword) => (
                                            <Chip
                                                label={keyword}
                                                key={keyword}
                                                variant="outlined"
                                                size="small"
                                            />
                                        ))}
                                    <Box mt={1}>
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                handleDeleteTrigger(
                                                    index,
                                                    trigger.id,
                                                )
                                            }
                                        >
                                            <Delete fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Paper>
                            )
                        })}

                        <Button
                            variant="outlined"
                            startIcon={<Add />}
                            onClick={() => setOpenModalAddTrigger(true)}
                        >
                            Adicionar Gatilho
                        </Button>
                    </Stack>

                    <Divider sx={{ my: 3 }} />

                    <Stack sx={{ width: "100%" }} spacing={2}>
                        <Typography variant="h6" gutterBottom>
                            Ações
                        </Typography>
                        {actions.map((action, index) => (
                            <Paper
                                key={index}
                                variant="outlined"
                                sx={{ p: 2, width: "100%" }}
                            >
                                <Typography>
                                    <Icon icon="skill-icons:instagram" />{" "}
                                    {actionTypes[action.actionType]}
                                </Typography>
                                <Typography
                                    sx={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {action.content}
                                </Typography>
                                {Number(action.delay) === 0 ? (
                                    <Typography>
                                        Enviar imediatamente
                                    </Typography>
                                ) : (
                                    <Typography>
                                        Enviar depois de {action.delay} minutos
                                    </Typography>
                                )}
                                {action.buttonLabel && (
                                    <Chip
                                        label="CTA adicionado"
                                        variant="outlined"
                                        size="small"
                                    />
                                )}
                                <Box mt={1}>
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            handleDeleteAction(index, action.id)
                                        }
                                    >
                                        <Delete fontSize="small" />
                                    </IconButton>
                                </Box>
                            </Paper>
                        ))}

                        <Button
                            variant="outlined"
                            startIcon={<Add />}
                            onClick={() => setOpenModalAction(true)}
                        >
                            Adicionar Ação
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    onClick={handleAddAutomation}
                    disabled={loading}
                    loading={loading}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalAutomation
